module.exports = __webpack_public_path__ + "img/product_6.ff2288c.svg";